// ui/export/capacitacionesExport.js  (Excel de las filas visibles; misma técnica que cuentas-list-export.js)
import xlsx from 'json-as-xlsx';

const CapacitacionesExport = (rows, cicloNombre = '') => {
  const xlsData = [
    {
      sheet: 'Capacitaciones',
      columns: [
        { label: 'FECHA', value: 'fecha' },
        { label: 'NOMBRE', value: 'nombre_capacitacion' },
        { label: 'MUNICIPIO', value: 'municipio_nombre' },
        { label: 'LOCALIDAD', value: 'localidad_nombre' },
        { label: 'NÚMERO DE ASISTENTES', value: row => +row.asistentes_count },
        { label: 'RESPONSABLE', value: 'responsable' },
        { label: 'ACTIVIDAD', value: 'actividad_nombre' },
      ],
      content: rows,
    },
  ];
  xlsx(xlsData, { fileName: `capacitaciones_${cicloNombre}` });
};

export default CapacitacionesExport;
